export const CONSENT_COOKIE = "cc_consent";
export const CONSENT_VERSION = "1";
export const SUBMIT_CURRENT_EVENT = "cc:submit-current";
export const CONSENT_UPDATED_EVENT = "cc:consent-updated";

export function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function readStoredConsent() {
  try {
    const raw = getCookie(CONSENT_COOKIE);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.v !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function hasCookieConsent() {
  return readStoredConsent() !== null;
}

export function requestCookieConsentIfNeeded() {
  if (hasCookieConsent()) return true;
  window.dispatchEvent(new CustomEvent(SUBMIT_CURRENT_EVENT));
  return false;
}
